import { useAppDisplayModeContext } from '@archipro-design/aria';
import { SearchFilterDesktop } from './SearchFilter.desktop';
import { SearchFilterMobile } from './SearchFilter.mobile';
import type { useSearchFilters } from '@modules/search/hook/use-search-filters';

export interface SearchFilterProp {
    filterDrawerOpen: boolean;
    toggleFilterDrawer: () => void;
    searchFilters: ReturnType<typeof useSearchFilters>;
    disableSort?: boolean;
    disableToggleFilter?: boolean;
    /** `revamp` renders the BC-4505 detail-page search-bar pill. */
    searchBarVariant?: 'default' | 'revamp';
    /** Flips the revamp search bar for the dark Projects tab. */
    searchBarTheme?: 'light' | 'dark';
    /** Placeholder for the revamp search input. */
    searchPlaceholder?: string;
}

export const SearchFilter: React.FC<SearchFilterProp> = (props) => {
    const { desktop } = useAppDisplayModeContext();

    return !desktop ? (
        <SearchFilterMobile {...props} />
    ) : (
        <SearchFilterDesktop {...props} />
    );
};
